<div class="fixed-sidebar responsive-sidebar">
  <app-app-sidebar [theme]="theme" (portalId)="getMenusByRoleId($event)"></app-app-sidebar>
</div>

<mat-sidenav-container
  class="mainWrapper"
  autosize
  autoFocus
  [ngClass]="{
    'sidebarNav-mini': options.sidenavCollapsed && options.navPos !== 'top' && !resView,
    'sidebarNav-horizontal': options.horizontal,
    cardBorder: options.cardBorder
  }"
  [dir]="options.dir!"
>
  <!-- ============================================================== -->
  <!-- Vertical Sidebar -->
  <!-- ============================================================== -->
  @if (!options.horizontal) {
    <mat-sidenav
      #leftsidenav
      [mode]="isOver ? 'over' : 'side'"
      [opened]="options.navPos === 'side' && options.sidenavOpened && !isOver && !resView"
      (openedChange)="onSidenavOpenedChange($event)"
      (closedStart)="onSidenavClosedStart()"
      class="sidebarNav"
    >
      <div class="flex-layout">
        <app-sidebar (toggleMobileNav)="sidenav.toggle()" [showToggle]="isOver"></app-sidebar>
        <ng-scrollbar class="position-relative" style="height: 100%">
          <mat-nav-list class="sidebar-list">
            @for (item of navItems; track item) {
              <app-nav-item [item]="item" (notify)="sidenav.toggle()"> </app-nav-item>
            }
          </mat-nav-list>
        </ng-scrollbar>
      </div>
    </mat-sidenav>
  }

  <!-- ============================================================== -->
  <!-- horizontal Sidebar -->
  <!-- ============================================================== -->
  @if (resView) {
    <mat-sidenav
      #leftsidenav
      [mode]="'over'"
      [opened]="options.sidenavOpened && !isTablet"
      (openedChange)="onSidenavOpenedChange($event)"
      (closedStart)="onSidenavClosedStart()"
      class="sidebarNav"
    >
      <app-sidebar> </app-sidebar>
      <ng-scrollbar class="position-relative" style="height: 100%">
        <mat-nav-list class="sidebar-list">
          @for (item of navItems; track item) {
            <app-nav-item [item]="item" (notify)="sidenav.toggle()"> </app-nav-item>
          }
        </mat-nav-list>
      </ng-scrollbar>
    </mat-sidenav>
  }

  <!-- ============================================================== -->
  <!-- Main Content -->
  <!-- ============================================================== -->
  <mat-sidenav-content class="contentWrapper" #content>
    <!-- ============================================================== -->
    <!-- VerticalHeader -->
    <!-- ============================================================== -->
    @if (!options.horizontal) {
      <app-header
        [showToggle]="!isOver"
        (toggleCollapsed)="toggleCollapsed()"
        (toggleMobileNav)="sidenav.toggle()"
        (optionsChange)="receiveOptions($event)"
      ></app-header>
    } @else {
      <!-- horizontal header -->
      <app-horizontal-header
        (toggleMobileNav)="sidenav.toggle()"
        (optionsChange)="receiveOptions($event)"
      ></app-horizontal-header>
    }
    @if (options.horizontal) {
      <app-horizontal-sidebar></app-horizontal-sidebar>
    }
    <div class="body-wrapper">
      <main
        class="pageWrapper"
        [ngClass]="{
          maxWidth: options.boxed
        }"
      >
        <app-breadcrumb></app-breadcrumb>
        <!-- ============================================================== -->
        <!-- Outlet -->
        <!-- ============================================================== -->
        <router-outlet></router-outlet>
        <!-- <div class="customizerBtn">
          <button
            mat-fab
            class="bg-error text-white"
            (click)="customizerRight.toggle()"
          >
            <mat-icon>settings</mat-icon>
          </button>
        </div> -->
      </main>
      <span class="body-footer mt-2"><img [src]="logo" alt="Logo" width="40" />&nbsp; by &nbsp; <img [src]="logoMi" alt="Logo" width="10" /> &nbsp; Misión Empresarial</span>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

@if (chatTarget(); as target) {
  <app-chat-candidato-drawer
    [idCandidato]="target.idCandidato"
    [phone]="target.phone"
    [nombre]="target.nombre"
    [desdePanelFab]="target.desdePanelFab ?? false"
    [visible]="true"
    (visibleChange)="onChatVisibleChange($event)"
  ></app-chat-candidato-drawer>
}

<!-- FAB global de chats WhatsApp: el propio componente se oculta fuera del portal Nodo (idPortal 3) o sin sesión. -->
<app-chat-global-fab></app-chat-global-fab>

<!-- Panel lateral derecho de la Guía de usuario (se abre desde el botón de ayuda del header). -->
<app-guia-usuario-drawer></app-guia-usuario-drawer>

<!-- ------------------------------------------------------------------
  Mobile Apps Sidebar
  ------------------------------------------------------------------ -->
